import React from "react";
import { Input as InputMantine, InputWrapperProps } from "@mantine/core";

const InputWrapper: React.FC<InputWrapperProps> = (props) => {
  return <InputMantine.Wrapper {...props} />;
};

export default InputWrapper;
